import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom"; // assumes react-router-dom v6

// Helper to decode JWT
function parseJwt(token) {
    try {
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split("")
                .map(c => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
                .join("")
        );
        return JSON.parse(jsonPayload);
    } catch (e) {
        return null;
    }
}

// Check if token expired
function isTokenExpired(token) {
    const payload = parseJwt(token);
    if (!payload || !payload.exp) return true;
    const now = Math.floor(Date.now() / 1000);
    return payload.exp < now;
}

// Component that checks token on page load
export const TokenChecker = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const token = localStorage.getItem("teacherToken"); // or wherever you store your token
        if (token && isTokenExpired(token)) {
            localStorage.removeItem("teacherToken");
            // If currently in /logged-in, redirect to home
            if (location.pathname === "/logged-in") {
                navigate("/", { replace: true });
            }
        }
        // No action if token is valid or not in /logged-in
    }, [location, navigate]);

    return null; // this component doesn't render anything
};